<template>
  <HKLFragment v-if="isAccept || hasPaid">
    <div class="row inline-flex" :class="{ edit: isEdit }">
      <div class="small-6">
        <TextField
          :label="$t('project.submission.paymentStatus')"
          :value="paidStatusText"
          :readonly="true"
        />
      </div>
      <div class="small-6">
        <TextField
          :label="$t('project.submission.paymentDate')"
          :value="paidDateText"
          :readonly="true"
        />
      </div>
    </div>
  </HKLFragment>
</template>
<script>
import lodash from 'lodash'
import { computed, unref, toRefs } from 'vue-demi'
import HKLFragment from '@/controls/Layout/HKLFragment.vue'
import TextField from '@/controls/TextField.vue'
import i18n from '@/utils/i18n'
import { useHasPaid, useIsAccepted, usePaidDate } from './hook'

export default {
  components: {
    TextField,
    HKLFragment,
  },
  props: {
    submission: {
      type: Object,
      require: true,
    },
    isContractor: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    let returnData = {}

    const {
      submission: submissionRef,
    } = toRefs(props)

    const isAccept = useIsAccepted(submissionRef)
    const paidDate = usePaidDate(submissionRef)
    const hasPaid = useHasPaid(submissionRef)
    const paidStatusText = computed(() => {
      const date = unref(paidDate)
      return date
        ? i18n.t('project.submission.paid').toUpperCase()
        : lodash.upperFirst(i18n.t('project.submission.processing').toLowerCase())
    })
    const paidDateText = computed(() => {
      const text = unref(paidDate)
      return text || i18n.t('emptyValue')
    })

    returnData = {
      ...returnData,
      isAccept,
      paidDate,
      hasPaid,
      paidStatusText,
      paidDateText,
    }

    return returnData
  },
}
</script>

<style lang="scss" scoped>
.inline-flex {
  display: inline-flex;
  vertical-align: top;
  width: 39.5%;
  ::v-deep .text-field {
    label {
      margin-top: 15px;
      margin-bottom: 5px;
      line-height: 1.43;
    }
    p {
      line-height: 1.43;
    }
  }
}
.edit {
  ::v-deep .text-field p {
    height: 40px;
    line-height: 40px;
    margin-bottom: 0;
  }
}
</style>
